// import React from 'react'
// import ReactDOM from 'react-dom'
// import ReactMessages from 'react-messages'
// import withTracker from "../containers/Full/withTracker";
// import {connect} from "react-redux";
// import {withRouter, Link } from "react-router-dom";
//
// class Messages extends React.PureComponent {
//     state = {
//         next: false,
//         message: 'Just an initial message',
//         newMessage: '',
//         icon: 'heart',
//         duration: 1,
//         error: false
//     }
//
//     handleSelect = (e) => {
//         const icon = e.target.value
//         this.setState({ icon, next: false })
//     }
//
//     handleDuration = (e) => {
//         const duration = Number(e.target.value)
//         this.setState({ duration, next: false })
//     }
//
//     handleError = () => {
//         const { error } = this.state
//         this.setState({ error: !error, next: false })
//     }
//
//     handleChange = (e) => {
//         const newMessage = e.target.value
//
//         this.setState({ newMessage, next: false })
//     }
//
//     handleClick = () => {
//         const { newMessage } = this.state
//
//         this.setState({
//             message: newMessage,
//             newMessage: '',
//             next: true
//         })
//     }
//
//     render() {
//         const { next, message, newMessage, icon, duration, error } = this.state
//         const durationInMilliseconds = duration * 1000
//
//         return (
//             <div>
//                 <h1>'react-messages' example</h1>
//                 <hr />
//                 <h2>Options:</h2>
//                 <label htmlFor='icon'>
//                     Choose the icon:
//                     <select onChange={this.handleSelect}>
//                         <option default value="heart">Heart</option>
//                         <option value="warning">Warning</option>
//                         <option value="info">Info</option>
//                         <option value="thumbs-up">Thumbs up</option>
//                         <option value="thumbs-down">Thumbs down</option>
//                     </select>
//                 </label>
//                 <br />
//                 <label htmlFor="duration">
//                     Choose the duration:
//                     <input
//                         onChange={this.handleDuration}
//                         value={duration}
//                         type='range'
//                         min='1'
//                         max='10'
//                         step='1'
//                     />
//                     <span>{duration} seconds</span>
//                 </label>
//                 <br />
//                 <label htmlFor="error">
//                     Choose if the message is an error:
//                     <input onChange={this.handleError} type="radio" name="error" value={true} checked={error === true}/> Is an error &nbsp;
//                     <input onChange={this.handleError} type="radio" name="error" value={false} checked={error === false}/> Is not an error
//                 </label>
//                 <p>Fill the input and Press the button to render a new message</p>
//                 <input onChange={this.handleChange} value={newMessage} />
//                 <button onClick={this.handleClick}>New Message</button>
//                 <ReactMessages
//                     message={message}
//                     next={next}
//                     error={error}
//                     icon={icon}
//                     duration={durationInMilliseconds}
//                 />
//             </div>
//         )
//     }
// }
//
// function mapStateToProps(store) {
//     return {
//         user: store.auth.user,
//     };
// }
//
//
// export default withTracker(withRouter(connect(mapStateToProps)(Messages)));


import React from 'react'
import { Message, MessageProvider } from 'react-message-context'
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link } from "react-router-dom";
import {connect} from "react-redux";
import { Chat } from '@progress/kendo-react-conversational-ui';
import * as marked from 'marked';
import '../styles/message.css';

function MessageTemplate(props) {
    let message = props.item;
    let parser = marked.setOptions({});
    let parsedMessage = parser.parse(message.text);
    let htmlToinsert = { __html: parsedMessage };
    return (
        <div className="k-bubble">
            <div dangerouslySetInnerHTML={htmlToinsert} />
        </div>
    );
}

class Messages extends React.Component {
    constructor(props){
        super(props);
        console.log("this user", this.props.user);
        this.user = {
            id: 1
        };
        this.bot = {
            id: 0
        };
        this.state = {
            messages: [{
                author: this.bot,
                text: 'Type in some _Markdown_ to see it **rendered** here'
            }]
        };
    }

    addNewMessage = (event) => {
        this.setState((prevState) => {
            return { messages: [...prevState.messages, event.message] };
        });
    };
    render() {

        return (
            <div>
                <Chat user={this.user}
                      messages={this.state.messages}
                      onMessageSend={this.addNewMessage}
                      width={400}
                      messageTemplate={MessageTemplate}>
                </Chat>
            </div>
        );
    }

    // render(){
    //     return(
    //         <MessageProvider locale="en" messages={{foo: 'FOO', qux: 'QUX'}}>
    //             <MessageProvider locale="fi" messages={{foo: 'FÖÖ', bar: 'BÄR'}}>
    //                 <ul>
    //                     <li>
    //                         <Message id="foo" />
    //                     </li>
    //                     <li>
    //                         <Message id="foo" locale="en" />
    //                     </li>
    //                     <li>
    //                         <Message id="bar" />
    //                     </li>
    //                     <li>
    //                         <Message id="bar" locale="en" />
    //                     </li>
    //                     <li>
    //                         <Message id="qux" />
    //                     </li>
    //                     <li>
    //                         <Message id="quux">xyzzy</Message>
    //                     </li>
    //                 </ul>
    //             </MessageProvider>
    //         </MessageProvider>
    //     );
    // }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user,
    };
}


export default withTracker(withRouter(connect(mapStateToProps)(Messages)));
